/** Pull a human-readable message from Laravel validation / axios errors */
export function formatAuthError(error) {
  const data = error?.response?.data;
  const errors = data?.errors;
  if (errors && typeof errors === 'object') {
    const firstMessage = Object.values(errors).flat().find(Boolean);
    if (firstMessage) {
      return firstMessage;
    }
  }
  if (typeof data?.message === 'string') {
    return data.message;
  }
  if (error?.message) {
    return error.message;
  }
  return 'Something went wrong.';
}
